import AlbumCover from './AlbumCover';
import SeekBar from './controls/SeekBar';
import VolumeControl from './controls/VolumeControl';
import LikeButton from './controls/LikeButton';
import FirePlayToggle from './controls/FirePlayToggle';
import { PrevIcon, NextIcon } from './icons';
import { usePlayer } from '../player/PlayerContext';

export default function PlayerBar() {
  const {
    audioRef, currentAlbum, isPlaying, togglePlay, next, prev,
    setCurrentTime, setDuration, isScrubbing, openNowPlaying,
  } = usePlayer();

  if (!currentAlbum) return null;

  const style = {
    '--album-accent': currentAlbum.accent,
  };

  return (
    <footer className="player" style={style}>
      <audio
        ref={audioRef}
        src={currentAlbum.track.src}
        onTimeUpdate={(e) => { if (!isScrubbing) setCurrentTime(e.currentTarget.currentTime); }}
        onLoadedMetadata={(e) => setDuration(e.currentTarget.duration || 0)}
        onEnded={next}
        preload="metadata"
      />

      {/* Desktop layout: left / center / right */}
      <div className="player-left player-desktop-only">
        <AlbumCover album={currentAlbum} className="player-cover" />
        <div className="player-meta">
          <div className="player-track-title">{currentAlbum.track.title}</div>
          <div className="player-track-artist">{currentAlbum.artist}</div>
        </div>
        <LikeButton albumId={currentAlbum.id} />
      </div>

      <div className="player-center player-desktop-only">
        <div className="player-controls">
          <button className="icon-btn" onClick={prev} aria-label="Previous"><PrevIcon /></button>
          <FirePlayToggle isPlaying={isPlaying} onClick={togglePlay} />
          <button className="icon-btn" onClick={next} aria-label="Next"><NextIcon /></button>
        </div>
        <SeekBar />
      </div>

      <div className="player-right player-desktop-only">
        <VolumeControl />
      </div>

      {/* Mobile compact layout */}
      <button
        className="player-mobile-only player-cover-btn"
        onClick={openNowPlaying}
        aria-label="Open now playing"
        style={{ padding: 0, background: 'none' }}
      >
        <AlbumCover album={currentAlbum} className="player-cover" />
      </button>
      <div
        className="player-mobile-only player-mobile-meta"
        onClick={openNowPlaying}
        role="button"
        tabIndex={0}
      >
        <div className="player-track-title">{currentAlbum.track.title}</div>
        <div className="player-track-artist">{currentAlbum.artist}</div>
      </div>
      <div className="player-mobile-only player-controls">
        <FirePlayToggle isPlaying={isPlaying} onClick={togglePlay} />
      </div>
    </footer>
  );
}
